<app-result-score-bar
  [rfiWeightedPercent]="rfiWeightedPercent()"
  [rfpWeightedPercent]="rfpWeightedPercent()"
  [rfdWeightedPercent]="rfdWeightedPercent()"
  [tooltipText]="tooltipText()"
/>
